<div [style.width]="width"></div>
